<template>

    <section class="bg-lifeboost-red-lighter">
        <svg width="0" height="0" class="hidden">
            <symbol fill="orange" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" id="star1">
                <path
                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.536.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.283.95l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z">
                </path>
            </symbol>
        </svg>
        <div class="max-w-screen-xl px-4 py-8 mx-auto md:py-16">
            <h4 class="font-bold text-center h2">
                See What Customers Are Saying...
            </h4>

            <div class="grid mt-12 gap-x-6 gap-y-6 lg:grid-cols-3">
                <div v-for="(group, index) in groupedTestimonials" :key="index" class="space-y-6">
                    <div v-for="(testimonial, tIndex) in group" :key="`testimonial-${tIndex}`"
                        class="pt-6 pb-12 bg-white">
                        <div class="flex flex-col items-center justify-center">
                            <img :src="testimonial.src" :alt="testimonial.srcAlt"
                                class="object-cover w-32 h-32 rounded-full" loading="lazy" />

                            <p class="flex items-center justify-center mx-auto mt-4 space-x-2 text-gray-300"><svg
                                    class="w-4 h-4">
                                    <use xlink:href="#star1"></use>
                                </svg><svg class="w-4 h-4">
                                    <use xlink:href="#star1"></use>
                                </svg><svg class="w-4 h-4">
                                    <use xlink:href="#star1"></use>
                                </svg><svg class="w-4 h-4">
                                    <use xlink:href="#star1"></use>
                                </svg><svg class="w-4 h-4">
                                    <use xlink:href="#star1"></use>
                                </svg></p>
                            <div class="px-6 mt-8 leading-4 text-center md:px-10 text-gray200 xl:px-14">
                                {{ testimonial.quote }}
                            </div>
                            <p class="px-8 mt-6 font-bold leading-5 text-center md:px-12 xl:px-16 text-gray200">
                                {{ testimonial.author }}
                            </p>
                            <p class="px-6 mt-1 leading-4 text-center md:px-10 text-15 text-gray200 xl:px-14">
                                {{ testimonial.role }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

</template>

<script setup>

const groupedTestimonials = computed(() => {
    let groups = [];
    for (let i = 0; i < testimonials.value.length; i += 3) {
        groups.push(testimonials.value.slice(i, i + 3));
    }
    return groups;
});

const testimonials = ref([
    {
        quote: "Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
        author: "Dr. Aaron Oxenrider",
        role: "Board Certified Chiropractic Physician and Regenerative Medicine Expert",
        src: "/assets/images/reviews-cookie-1.jpg",
        srcAlt: "Dr. name"
    },
    {
        quote: "“Best tasting low acid coffee ever! And it’s great on your teeth!”",
        author: "Dr. Gary Sanchez",
        role: "Board Certified Dentist",
        src: "/assets/images/reviews-cookie-4.jpg",
        srcAlt: "Dr. name"
    },
    {
        quote: "“Wow! This coffee is incredible! Super smooth and the lowest acid coffee I've ever drank. It doesn't hurt my stomach at all! Careful though, it goes down really fast! It's my perfect way to start out my morning with a cool smooth burst of energy. Thanks Dr. Charles!“",
        author: "John Rowley",
        role: "America's Lifestyle Strategist, Best Selling Author and Speaker",
        src: "/assets/images/reviews-cookie-7.png",
        srcAlt: "Dr. name"
    },
    {
        quote: "Lifeboost Coffee is one of the healthiest, smoothest coffee's I've ever had. The ultra low acidity makes it perfect for those with stomach issues and digestive problems. Couple that with the rich, full bodied flavor and it's a treat | look forward to every day.",
        author: "Joseph R. Feste, M.D. FACOG, AACS, AACG, Natural Bio Health, Hormones & Weight Loss.",
        role: "Dr. Feste is a member ofthe American Society of Bariatric Physicians. He has exfensive experience in the fields of Obstetrics & Gynecology.",
        src: "/assets/images/reviews-cookie-2.jpg",
        srcAlt: "Dr. name"
    },
    {
        quote: "“My favorite way to start the day and | love knowing it's fair trade! I'm super picky about coffee and this is the perfect bold flavor but not bitter. The smell is amazing too! Thanks, Lifeboost!”",
        author: "Erin Nielsen, PT, CHC",
        role: "theyouthmethod.com",
        src: "/assets/images/reviews-cookie-5.png",
        srcAlt: "Dr. name"
    },
    {
        quote: "“This is the only coffee I drink at home and almost always never travel without!”",
        author: "Matt Clark",
        role: "Entrepreneur, Investor, Chairman of Amazing.com, Inc.",
        src: "/assets/images/reviews-cookie-8.jpg",
        srcAlt: "Dr. name"
    },
    {
        quote: "“Wow. Having studied health and anti-aging for years as well as owning several anti-aging medical clinics, I'm well aware of the health research behind a good cup of coffee. After tasting Lifeboost, | was WOW'ed by the difference. Most coffees don't taste that good! They seem bland in comparison. The ultra low acidity is definitely a PLUS as well. Keep up the good work!”",
        author: "Mike Clark, MBA, JD, PHD, ABHRT, FAARM",
        role: "Doctorate in Natural Medicine, Health Practitioner Diplomate in the Clinical Science of Anti-Aging, Fellow and Advanced Fellow of Anti-Aging, Regenerative & Functional Medicine.",
        src: "/assets/images/reviews-cookie-3.jpg",
        srcAlt: "Dr. name"
    },

    {
        quote: "“Lifeboost is by far the smoothest, most delicious coffee I've ever tasted. Whether I'm using intermittent fasting or just need a burst of ‘energy and focus for my intense work load, Lifeboost delivers the cleanest, purest coffee energy you can find. | look forward to my daily cup (or two) each day to help boost my immune health and crease my productivity.“",
        author: "Shaun Hadsall",
        role: "Owner of GetLeanAfter40",
        src: "/assets/images/reviews-cookie-6.png",
        srcAlt: "Dr. name"
    },
]);

defineBuilderComponent({
    friendlyName: 'CustomersReviews',
    ignored: true
})
</script>